/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.214.1-v202610292312-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * The input features of the template
 */
export interface InputFeatureV1 {
    /**
     * Stable identifier for a feature that persists across template versions
     */
    "canonicalId"?: string;
    /**
     * Description of the input feature
     */
    "description"?: string;
    /**
     * Unique identifier of the input feature; omit on create
     */
    "id"?: string;
    /**
     * Name of the input feature
     */
    "name"?: string;
    /**
     * Item-type-specific metadata restricting the item bound to this input. Currently only the unit of measure is captured: Signal uses the Value Unit Of Measure key and Scalar uses the Unit Of Measure key; an absent key indicates the Any-UOM opt-out and an empty-string value indicates the dimensionless unit. Structured as an extensible map so additional item-type-specific properties can be added without a schema change.
     */
    "outputItemMetadata"?: { [key: string]: string; };
    /**
     * The item type an item bound to this input must satisfy (e.g., Signal, Scalar, Condition). Only applicable to ITEM_ID and ITEM_ID_LIST inputs; if absent, any item type is allowed.
     */
    "outputItemType"?: string;
    /**
     * Type of the feature output
     */
    "outputType"?: OutputTypeEnum;
    "required"?: boolean;
}

export const OutputTypeEnum = {
    TEXT: 'TEXT',
    NUMERIC: 'NUMERIC',
    ITEMID: 'ITEM_ID',
    BOOLEAN: 'BOOLEAN',
    TEXTLIST: 'TEXT_LIST',
    NUMERICLIST: 'NUMERIC_LIST',
    ITEMIDLIST: 'ITEM_ID_LIST'
} as const;

export type OutputTypeEnum = typeof OutputTypeEnum[keyof typeof OutputTypeEnum];
